import React from 'react';
export function IntroSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-gray-700 text-lg leading-relaxed space-y-4" data-id="element-2937">
      <p data-id="element-2938">
        Advancements in the metalworking industry have led to new, innovative
        ways of increasing productivity. One of the most popular ways of doing
        so (creating many new buzzwords in the process) has been the discovery
        of new, high-productivity toolpaths. Terms like trochoidal milling, high
        speed machining, adaptive milling, feed milling, and High Efficiency
        Milling are a handful of the names given to these cutting-edge
        techniques.
      </p>
      <p data-id="element-2939">
        With multiple techniques being described with somewhat similar terms,
        there is some confusion as to what each is referring to. High Efficiency
        Milling (HEM) and High Speed Machining (HSM) are two commonly used terms
        and techniques that can often be confused with one another. Both
        describe techniques that lead to increased material removal rates and
        boosted productivity. However, the similarities largely stop there.
      </p>
    </div>;
}